import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-396d7c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Окончание подписки:", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "statistic-page-tariffs__important-info__left" }, " Отчетов осталось: ", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "statistic-page-tariffs__important-info__right" }

import { statisticApi } from '@/shared/api'
import { useUser } from '@/shared/composables'
import { DATE_FORMAT } from '@/shared/constants'
import { getDateFormat, showErrorMessage } from '@/shared/utils'
import { computed, ref, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  additionalLines: Object,
},
  setup(__props) {

const props = __props



const subscriptionEndDate = computed(() =>
  getDateFormat(new Date(user.value.organization.block_at), DATE_FORMAT.dmyLong)
)

const { user } = useUser()
const tariffReportUsage = ref(null)
const tariffReportCount = ref(null)
const userReportUsage = ref(null)

const getTariffs = async (): Promise<void> => {
  const [error, response] = await statisticApi.getTariffStatistic()

  if (error) {
    showErrorMessage(error)
  } else {
    if (response.data.has_tariff) {
      tariffReportUsage.value = response.data.used_report_count
      tariffReportCount.value = response.data.report_count
      userReportUsage.value = response.data.personal_report_count
    }
  }
}

onMounted(async () => {
  await getTariffs()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "statistic-page-tariffs__info" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 12 }, {
        default: _withCtx(() => [
          _hoisted_1,
          (tariffReportUsage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Общий расход отчетов:"))
            : _createCommentVNode("", true),
          (userReportUsage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Ваш расход отчетов:"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalLines, (rowName, rowValue) => {
            return (_openBlock(), _createElementBlock("p", null, _toDisplayString(rowValue), 1))
          }), 256)),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 12 }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(subscriptionEndDate)), 1),
          (tariffReportUsage.value && !tariffReportCount.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(tariffReportUsage.value) + " отчетов ", 1))
            : _createCommentVNode("", true),
          (userReportUsage.value && !tariffReportCount.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(userReportUsage.value) + " отчетов ", 1))
            : _createCommentVNode("", true),
          (tariffReportUsage.value && tariffReportCount.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(tariffReportUsage.value) + " отчетов из " + _toDisplayString(tariffReportCount.value), 1))
            : _createCommentVNode("", true),
          (userReportUsage.value && tariffReportCount.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(userReportUsage.value) + " отчетов из " + _toDisplayString(tariffReportCount.value), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalLines, (rowName, rowValue) => {
            return (_openBlock(), _createElementBlock("p", null, _toDisplayString(rowName), 1))
          }), 256)),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(user).organization.package_count), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})